import type { StarsWebExtraWallet } from '../types';

export const getIsWalletBonusCash = (wallet?: StarsWebExtraWallet) =>
  wallet?.awardingType === 'REDEEMABLE';
export const getIsWalletFreeBet = (wallet?: StarsWebExtraWallet) =>
  wallet?.awardingType === 'NON_REDEEMABLE';
